<template lang="pug">
  v-card.rounded-lg.px-6.py-3(outlined)
    v-row(align="center")
      v-col(cols="7")
        v-row(align="center")
          v-col.grow
            div
              .text-md.font-semibold Publish in offers section in customer profile
              .text-sm Offer will be listed in customer app and profile
          v-col.shrink
            y-switch.mb-n2(v-model="selected" disabled)
      v-divider.neutral300(vertical)
      v-col.py-0(cols="5")
        customer-app-offer-preview
</template>

<script>
import CustomerAppOfferPreview from "@/components/clinic/marketing/CustomerAppOfferPreview.vue";

export default {
  components: {
    CustomerAppOfferPreview
  },
  data() {
    return {
      selected: true
    }
  },
}
</script>


<style scoped>

</style>